module.exports = __webpack_public_path__ + "img/VSM-Unternehmenszentrale.efba627a.jpg";